import React, { useContext, useState, useEffect, useRef } from "react";
import "../../../assests/css/teachers/TeacherExam.css";
import TeacherMasterLayout from "../../../layouts/TeacherMasterLayout";
import { FaDownload, FaEye, FaEdit, FaTrash } from "react-icons/fa";
import { X } from "lucide-react";
import axios from "axios";
import { AppContext } from "../../../context/Appcontext";

const TeacherExam = () => {
  const fileInputRef = useRef(null);
  const { baseUrl, baseUrlForFiles, loggedInTeacher } = useContext(AppContext);

  const [teModalOpen, setTeModalOpen] = useState(false);
  // const [downloading, setDownloading] = useState(false);
  const [uploading, setUploading] = useState(false);
  // const [examSchedule, setExamSchedule] = useState([]);
  const [examSchedule, setExamSchedule] = useState(null);
  const [myCourses, setMyCourses] = useState([]);
  const [selectedSubject, setSelectedSubject] = useState(null);
  const [semester, setSemester] = useState("");
  const [selectedFile, setSelectedFile] = useState(null);

  const [recentExams, setRecentExams] = useState([]);
  const [previewImage, setPreviewImage] = useState(null);

  // ── Load teacher courses ──
  const loadMyCourses = () => {
    const teacher =
      loggedInTeacher || JSON.parse(localStorage.getItem("teacher"));
    const formData = new FormData();
    formData.append("ngteacher_id", teacher?.id);
    axios
      .post(`${baseUrl}/teacher/course/viewAllTeacherCourse`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((response) => {
        if (response.data.success === true) {
          setMyCourses(response.data.courses);
        }
      })
      .catch((error) => console.log(error));
  };
  // const loadExamSchedule = () => {
  //   const teacher =
  //     loggedInTeacher || JSON.parse(localStorage.getItem("teacher"));

  //   const formData = new FormData();

  //   formData.append("ngteacher_id", teacher.id);

  //   axios
  //     .post(`${baseUrl}/teacher/exam/viewExamSchedule`, formData)
  //     .then((response) => {
  //       //   setExamSchedule(response.data.exam);
  //       // }).then((response) => {
  //       console.log(response.data);
  //       setExamSchedule(response.data.exam);
  //     })
  //     .catch(console.log);
  // };
  const loadExamSchedule = () => {
  const teacher =
    loggedInTeacher || JSON.parse(localStorage.getItem("teacher"));

  console.log("Logged in Teacher:", teacher);

  if (!teacher) {
    console.log("Teacher not found in localStorage");
    return;
  }

  const departmentId = teacher.ngdepartment_id;

  console.log("Teacher Department ID:", departmentId);

  if (!departmentId) {
    console.log("Department ID not found");
    return;
  }

  axios
    .get(`${baseUrl}/teacher/exam/latestDepartmentSchedule`, {
      params: {
        ngdepartment_id: departmentId,
      },
    })
    .then((response) => {
      console.log("Latest Department Exam Schedule:", response.data);

      if (response.data.success) {
        setExamSchedule(response.data.exam);
      }
    })
    .catch((error) => {
      console.log(
        "Exam Schedule Error:",
        error.response?.data || error.message
      );
    });
};
  // ── Load exams uploaded by this teacher ──
  const loadMyExams = () => {
    const teacher =
      loggedInTeacher || JSON.parse(localStorage.getItem("teacher"));
    axios
      .get(`${baseUrl}/teacher/exam/viewAllExams`)
      .then((response) => {
        // console.log("API Response:", response.data);
        setRecentExams(response.data.exam);
        // console.log(response.data.exam);
        //   console.log("API Response:", response.data);
      })
      .catch((error) => console.log(error));
    // axios
    //   .get(`${baseUrl}/teacher/exam/viewAllExams`)
    //   .then((response) => {
    //     const allExams = response.data.exam || [];
    //     // Filter only exams matching teacher's courses
    //     const teacherCourseIds = myCourses.map((c) => c.ngcourse_id);
    //     const filtered = allExams.filter((e) =>
    //       teacherCourseIds.includes(e.ngcourse_id)
    //     );
    //     setRecentExams(filtered);
    //   })
    //   .catch((error) => console.log(error));
  };

useEffect(() => {
  loadMyCourses();
  loadExamSchedule();
}, []);

  useEffect(() => {
    if (myCourses.length > 0) {
      loadMyExams();
    }
  }, [myCourses]);

  /* SUBJECT CLICK */
  const handleSubjectClick = (course) => {
    setSelectedSubject(course);
    setSemester("");
    setSelectedFile(null);
  };

  /* FILE SELECT — JPG only */
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) {
      setSelectedFile(null);
      return;
    }

    const fileExt = file.name.split(".").pop().toLowerCase();
    const isJpg =
      ["image/jpeg", "image/jpg"].includes(file.type) &&
      ["jpg", "jpeg"].includes(fileExt);

    if (!isJpg) {
      alert("Sirf JPG file upload kar sakte hain (.jpg ya .jpeg).");
      e.target.value = "";
      setSelectedFile(null);
      return;
    }

    setSelectedFile(file);
  };

  /* UPLOAD EXAM PAPER */
  const handleUpload = () => {
    if (!selectedSubject || !selectedFile) {
      alert("Course aur JPG file dono select karo");
      return;
    }

    const fileExt = selectedFile.name.split(".").pop().toLowerCase();
    const isJpg =
      ["image/jpeg", "image/jpg"].includes(selectedFile.type) &&
      ["jpg", "jpeg"].includes(fileExt);

    if (!isJpg) {
      alert("Sirf JPG file upload kar sakte hain (.jpg ya .jpeg).");
      setSelectedFile(null);
      return;
    }

    const teacher =
      loggedInTeacher || JSON.parse(localStorage.getItem("teacher"));
    setUploading(true);

    const formData = new FormData();
    console.log(selectedSubject);
    // formData.append("ngdepartment_id", selectedSubject.ngteacher?.ngdepartment_id || "");
    // formData.append("ngprogramme_id", selectedSubject.ngteacher?.ngprogramme_id || "");
    formData.append("ngcourse_id", selectedSubject.ngcourse_id);
    formData.append("ngteacher_id", teacher.id);
    formData.append("semester", semester || "N/A");
    formData.append("fileName", selectedFile);

    axios
      .post(`${baseUrl}/teacher/exam/addTeacherExam`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((response) => {
        setUploading(false);
        if (response.data.success === true) {
          alert("Exam paper upload ho gaya!");
          setTeModalOpen(false);
          setSelectedSubject(null);
          setSemester("");
          setSelectedFile(null);
          loadMyExams();
        }
      })
      // .catch((error) => {
      //   setUploading(false);
      //   console.log(error);
      //   // alert("Upload failed. Please try again.");
      // });
      .catch((error) => {
        setUploading(false);

        console.log(error.response.data);
        console.log(error.response.data.errors);

        alert(JSON.stringify(error.response.data.errors));
      });
  };

  /* DOWNLOAD SCHEDULE */
  // const handleDownloadSchedule = async () => {
  //   try {
  //     setDownloading(true);
  //     const response = await fetch(
  //       "http://localhost:5000/api/admin/exam-schedule/download",
  //       { method: "GET" },
  //     );
  //     if (!response.ok) throw new Error("Failed");
  //     const blob = await response.blob();
  //     const url = window.URL.createObjectURL(blob);
  //     const a = document.createElement("a");
  //     a.href = url;
  //     a.download = "Exam_Schedule.pdf";
  //     document.body.appendChild(a);
  //     a.click();
  //     a.remove();
  //     window.URL.revokeObjectURL(url);
  //   } catch (error) {
  //     alert("Exam schedule download nahi ho saka");
  //   } finally {
  //     setDownloading(false);
  //   }
  // };

  return (
    <TeacherMasterLayout>
      {/* TOPBAR */}
      <header className="ta-topbar">
        <h3>Welcome, Teacher 👋</h3>
        <div className="ta-profile">👤</div>
      </header>

      <div className="te-page">
        {/* HEADER */}
        <div className="te-header">
          <h1>Manage Exams</h1>
        </div>
        {/* Exam Schedule */}
        {/* <div className="te-schedule-wrap">
          <h2>Exam Schedule</h2>

          {examSchedule.length > 0 ? (
            examSchedule.map((item) => (
              <div key={item.id} className="te-schedule-card">
                <h4>{item.ngcourse?.name}</h4>

                <p>{item.ngprogramme?.progName}</p>

                <p>Semester {item.semester}</p>

              
                <a
                  href={`${baseUrlForFiles}/${item.fileName}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    src={`${baseUrlForFiles}/${item.fileName}`}
                    alt="Exam Schedule"
                    width="250"
                  />
                </a>
              </div>
            ))
          ) : (
            <p>No Exam Schedule Available.</p>
          )}
        </div> */}
        <div className="te-schedule-wrap">
  <h2>Exam Schedule</h2>

  {examSchedule ? (
    <div className="te-schedule-card">

      <h4>
        {examSchedule.ngcourse?.name || "Exam Schedule"}
      </h4>

      <p>
        {examSchedule.ngprogramme?.progName || ""}
      </p>

      <p>
        Semester {examSchedule.semester}
      </p>

      <a
        href={`${baseUrlForFiles}/${examSchedule.fileName}`}
        target="_blank"
        rel="noopener noreferrer"
      >
        <img
          src={`${baseUrlForFiles}/${examSchedule.fileName}`}
          alt="Latest Exam Schedule"
          width="250"
        />
      </a>

    </div>
  ) : (
    <p>No Exam Schedule Available.</p>
  )}
</div>
       

        {/* CREATE BUTTON */}
        <div className="te-create-wrap">
          <button
            className="te-create-btn"
            onClick={() => setTeModalOpen(true)}
          >
            Upload Exam Paper
          </button>
        </div>

        {/* TABLE */}
        <div className="te-table-wrap">
          <h2>Recently Uploaded Exam Papers</h2>

          <table className="te-table">
            <thead>
              <tr>
                <th>Course</th>
                <th>Semester</th>
                <th>File</th>
              </tr>
            </thead>
            <tbody>
              {recentExams.length > 0 ? (
                recentExams.map((exam) => (
                  <tr key={exam.id}>
                    <td data-label="Course">{exam.ngcourse?.name}</td>
                    <td data-label="Semester">{exam.semester}</td>
                    <td data-label="File">
                      <a
                        href={`${baseUrlForFiles}/${exam.fileName}`}
                        target="_blank"
                        rel="noreferrer"
                      >
                        {exam.fileName}
                      </a>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td
                    colSpan={3}
                    style={{
                      textAlign: "center",
                      padding: "2rem",
                      color: "#999",
                    }}
                  >
                    Koi exam paper upload nahi kiya gaya abhi tak.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>

      {/* MODAL - COURSE SELECT + UPLOAD */}
      {teModalOpen && (
        <div className="te-modal-overlay">
          <div className="te-modal">
            {/* MODAL HEADER */}
            <div className="te-modal-header">
              <h3>Upload Exam Paper</h3>
              <X
                size={20}
                style={{ cursor: "pointer" }}
                onClick={() => {
                  setTeModalOpen(false);
                  setSelectedSubject(null);
                  setSemester("");
                  setSelectedFile(null);
                }}
              />
            </div>

            {/* STEP 1 - Select Course */}
            {!selectedSubject ? (
              <div className="te-subject-list">
                <p style={{ marginBottom: "0.75rem", fontWeight: 600 }}>
                  Apna course select karo:
                </p>
                {myCourses.length > 0 ? (
                  myCourses.map((course) => (
                    <button
                      key={course.id}
                      className="te-subject-btn"
                      onClick={() => handleSubjectClick(course)}
                    >
                      {course.ngcourse?.name || "—"}
                    </button>
                  ))
                ) : (
                  <p style={{ color: "#999" }}>Koi course available nahi.</p>
                )}
              </div>
            ) : (
              /* STEP 2 - Upload File */
              <div className="te-subject-list">
                <p style={{ marginBottom: "0.5rem" }}>
                  <strong>Course:</strong> {selectedSubject.ngcourse?.name}
                </p>

                <div style={{ marginBottom: "1rem" }}>
                  <label
                    style={{
                      fontWeight: 600,
                      display: "block",
                      marginBottom: "0.4rem",
                    }}
                  >
                    Semester:
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="e.g. 3"
                    value={semester}
                    onChange={(e) => setSemester(e.target.value)}
                    style={{
                      width: "100%",
                      padding: "0.5rem",
                      borderRadius: "8px",
                      border: "1px solid #ddd",
                    }}
                  />
                </div>

                <div style={{ marginBottom: "1rem" }}>
                  <label
                    style={{
                      fontWeight: 600,
                      display: "block",
                      marginBottom: "0.4rem",
                    }}
                  >
                    Exam Paper File (JPG only):
                  </label>
                  <input
                    type="file"
                    className="form-control"
                    accept=".jpg,.jpeg,image/jpeg"
                    onChange={handleFileChange}
                  />
                  <small
                    style={{
                      color: "#888",
                      display: "block",
                      marginTop: "0.3rem",
                    }}
                  >
                    Sirf .jpg / .jpeg file allowed hai.
                  </small>
                </div>

                <div style={{ display: "flex", gap: "0.75rem" }}>
                  <button
                    className="te-subject-btn"
                    style={{ background: "#eee", color: "#333" }}
                    onClick={() => setSelectedSubject(null)}
                  >
                    ← Back
                  </button>
                  <button
                    className="te-create-btn"
                    onClick={handleUpload}
                    disabled={uploading}
                  >
                    {uploading ? "Uploading..." : "Upload"}
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
      )}
      {previewImage && (
        <div className="te-image-preview" onClick={() => setPreviewImage(null)}>
          <span className="te-close">&times;</span>

          <img
            src={previewImage}
            alt="Preview"
            className="te-preview-img"
            onClick={(e) => e.stopPropagation()}
          />
        </div>
      )}

      {/* HIDDEN FILE INPUT */}
      <input
        type="file"
        ref={fileInputRef}
        style={{ display: "none" }}
        onChange={() => {}}
      />
    </TeacherMasterLayout>
  );
};

export default TeacherExam;
